export default "__VITE_ASSET__BEZsRlQP__"